import React from "react";
import { NavbarAndContentWrapper, Wrapper } from "./styles";
import Navbar from "../navbar";

function Container({ children, navbarItems }) {
  return (
    <Wrapper>
      <NavbarAndContentWrapper>
        <Navbar items={navbarItems} />
        {children}
      </NavbarAndContentWrapper>
    </Wrapper>
  );
}

export default Container;
